import { datadogRum } from '@datadog/browser-rum';

export class DatadogSentEvent {
    addAction(name:string, level:string, message:string) {
        datadogRum.init({
            applicationId: '01abf261-b325-40f9-b8da-d357057ac189',
            clientToken: 'pub56175736be4966f2c0408f04f4e866f2',
            site: 'us5.datadoghq.com',
            service: 'digital',
            env: process?.env?.APP_ENV || 'production',
            sessionSampleRate: 100,
            sessionReplaySampleRate: 100
        });
        datadogRum.addAction(name, {level, message });
    }
}

